import { render, staticRenderFns } from "./TableInfo.vue?vue&type=template&id=744f9020&scoped=true&"
import script from "./TableInfo.vue?vue&type=script&lang=js&"
export * from "./TableInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f9020",
  null
  
)

export default component.exports